import * as actions from "./actionsTypes";
import VacationRequestServices from "./vacationRequest.service";

export const getVacationRequestsByEmployee = (empleadoId) => async (dispatch) => {
  try {
    dispatch({ type: actions.IS_LOADING_VACATION_REQUESTS, payload: true });
    const resp = await VacationRequestServices.getRequestsByEmployee(empleadoId);
    dispatch({
      type: actions.GET_VACATION_REQUESTS,
      payload: resp.data,
    });
    dispatch({ type: actions.CLEAR_ERROR }); 
  } catch (ex) {
    dispatch({
      type: actions.FAIL_VACATION_REQUESTS,
      payload: "Error al cargar solicitudes",
    });
  } finally {
    dispatch({ type: actions.IS_LOADING_VACATION_REQUESTS, payload: false });
  }
};

// Crear solicitud
export const saveVacationRequest = (data, setShowModal) => async (dispatch) => {
  try {
    dispatch({ type: actions.IS_SAVE_VACATION_REQUEST, payload: true });
    await VacationRequestServices.createRequest(data);
    setShowModal(false);
    dispatch(getVacationRequestsByEmployee(data.codigo_empleado));
    dispatch({ type: actions.CLEAR_ERROR }); 
  } catch (ex) {
    dispatch({
      type: actions.FAIL_SAVE_VACATION_REQUEST,
      payload: ex.response?.data?.non_field_errors?.[0] || "Error al guardar solicitud"
    });
  } finally {
    dispatch({ type: actions.IS_SAVE_VACATION_REQUEST, payload: false });
  }
};

// Actualizar solicitud
export const updateVacationRequest = (id, data, setShowModal) => async (dispatch) => {
  try {
    dispatch({ type: actions.IS_SAVE_VACATION_REQUEST, payload: true });
    const resp = await VacationRequestServices.updateRequest(id, data);
    dispatch({ type: actions.UPDATE_VACATION_REQUEST_SUCCESS, payload: resp.data });
    if (setShowModal) setShowModal(false);
    dispatch(getVacationRequestsByEmployee(data.codigo_empleado));
    dispatch({ type: actions.CLEAR_ERROR }); 
    return true;
  } catch (ex) {
    dispatch({
      type: actions.FAIL_SAVE_VACATION_REQUEST,
      payload: ex.response?.data?.non_field_errors?.[0] || "Error al guardar solicitud"
    });
    return false;
  } finally {
    dispatch({ type: actions.IS_SAVE_VACATION_REQUEST, payload: false });
  }
};


// Eliminar solicitud
export const deleteVacationRequest = (id, setShowModal, empleadoId) => async (dispatch) => {
  try {
    dispatch({ type: actions.IS_SAVE_VACATION_REQUEST, payload: true });
    await VacationRequestServices.deleteRequest(id);
    setShowModal(false);
    dispatch(getVacationRequestsByEmployee(empleadoId));
    dispatch({ type: actions.CLEAR_ERROR });
  } catch (ex) {
    dispatch({ type: actions.FAIL_SAVE_VACATION_REQUEST, payload: "Error al eliminar solicitud" });
  } finally {
    dispatch({ type: actions.IS_SAVE_VACATION_REQUEST, payload: false });
  }
};

export const clearVacationRequestError = () => (dispatch) => {
  dispatch({
    type: actions.CLEAR_ERROR
  });
};